import { Button, Link, Para, Stack } from '@drycut/ui-components';
import { twJoin } from 'tailwind-merge';

type Props = {
  onAccept: () => void;
  onCancel: () => void;
  open?: boolean;
};

export function RulesAcceptance({ onAccept, onCancel }: Props): React.ReactElement {
  const linkClasses = twJoin(
    'underline text-white decoration-white decoration-1 font-semibold',
    'underline-offset-2 transition hover:text-slate-200 hover:decoration-slate-300',
  );

  const whiteButtonClasses = twJoin(
    'bg-white border-white px-8',
    'hover:bg-slate-200 hover:border-slate-200',
    'active:bg-slate-300 active:border-slate-300',
  );

  return (
    <div className="flex grow w-full h-full">
      <div className="absolute inset-0 bg-white/80 z-40" />

      <div className="absolute z-50 w-full h-full inset-0 flex items-center justify-center">
        <Stack gap={4} className="text-white items-center bg-primary-600 p-5 w-3/4">
          <Para className="items-center" align="center">
            Deine Wunschzeit ist nicht frei?
            <br />
            Wir haben Zeit für Dich!{' '}
            <Para as="strong" weight="bold">
              Buche spontan
            </Para>{' '}
            gemäss aktueller Wartezeit (Cut Now). Dort gibt es{' '}
            <Para as="strong" weight="bold">
              IMMER Platz
            </Para>
            !
          </Para>

          <Button
            size="small"
            onClick={onCancel}
            color="secondary"
            textClassName="text-slate-800"
            className={whiteButtonClasses}
          >
            Cut Now
          </Button>

          <Para className="items-center text-pretty" align="center">
            Mit der Reservierung stellt das System Dich zum gewählten Zeitpunkt in die Schlange (+/-
            10 Min). Wir garantieren aber{' '}
            <Para as="strong" weight="bold">
              nicht
            </Para>
            , dass Du{' '}
            <Para as="strong" weight="bold">
              genau
            </Para>{' '}
            zum gewählten Zeitpunkt dran kommst.
          </Para>

          <Button
            size="small"
            onClick={onAccept}
            color="secondary"
            textClassName="text-slate-800"
            className={whiteButtonClasses}
          >
            OK
          </Button>

          <Para>
            <Link href="https://www.drycut.ch/konzept" className={linkClasses}>
              Hier
            </Link>{' '}
            findest Du mehr Infos zur Reservierung.
          </Para>
        </Stack>
      </div>
    </div>
  );
}
